import Slider from 'react-slick';

import styles from './Slider.module.css';

export const MainSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false
  };

  return (
    <div className={styles.sliderWrapper}>
      <Slider {...settings}>
        <div className={`${styles.slides} ${styles.slideA}`}></div>
        <div className={`${styles.slides} ${styles.slideB}`}></div>
        <div className={`${styles.slides} ${styles.slideC}`}></div>
        <div className={`${styles.slides} ${styles.slideD}`}></div>
        <div className={`${styles.slides} ${styles.slideE}`}></div>
      </Slider>
    </div>
  );
}
